import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import { FadeInOut } from './FadeInOut'


const BtnList = ({ item, history, labID, onChangeRef }) => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const dropdownRef = useRef();
    const onMenuClick = (item) => (e) => {
        if (item.link) { history.push(item.link); }
        
        if (item.id) {
            e.preventDefault();

            dispatch(actionsModal.toggleModal(item.id, true))
        }

        if (item.onClick) { item.onClick(); }
    }

    const dropdownAlignRight = () => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting && dropdownRef.current) {
                    dropdownRef.current.style.right = '0';
                }
            },
            {
                root: null, 
                rootMargin: '0px',
                threshold: 1,
            }
        );
    
        if (dropdownRef.current) { observer.observe(dropdownRef.current); }
    };

    const onMouseEnter = () =>  { if (item.items && item.items.length > 0) { setOpen(true); } };
    const onMouseLeave = (e) => setOpen(false);
    
    useEffect(() => {
        dropdownAlignRight();
    }, [ labID, item ])

    useEffect(() => {
        if (onChangeRef && dropdownRef.current) {
            onChangeRef(dropdownRef.current);
        }
    },[dropdownRef, onChangeRef]);

    useEffect(() => {
        window.addEventListener('resize', dropdownAlignRight);

        return () => window.removeEventListener('resize', dropdownAlignRight);
    }, [])

    return (
        <div 
            className={`lab-btn-item${((item.items && item.items.length > 0) || item.id || item.link) 
                    ? '' : ' cursor-default'}`} 
            onClick={() => setOpen(!open)} 
            onMouseEnter={onMouseEnter} 
            onMouseLeave={onMouseLeave}
        >
            <div className='lab-btn-item-title' onClick={onMenuClick(item)}>
                {item.title}
            </div>

            {(item.items && item.items.length > 0)
                ?
                <FadeInOut 
                    className='lab-btn-item-dropdown' 
                    enter={open} 
                    ref={dropdownRef}
                >
                    <div className='dashboard-dropdown-menu ua-box'>
                        {item.items.map((d, k) => (
                            <div 
                                className='lab-btn-item-dropdown-item'  
                                onClick={onMenuClick(d)}
                                key={k}
                            >
                                {d.label}
                            </div>
                        ))}
                    </div>
                </FadeInOut>
                :
                null}
        </div>
    )
}


export { BtnList }
